import { Controller } from 'react-hook-form';
import { QDatepicker, QFormControl } from '@qualio/ui-components';
import { formatDatePickerComponentDateToString } from '../../../utils/datetimeUtils';

export interface DateFilterProps {
  name: string;
  label: string;
  placeholder: string;
  dataCy: string;
}

export const DateFilter = ({ name, label, placeholder, dataCy }: DateFilterProps) => {
  return (
    <QFormControl label={label} data-cy={dataCy} w="300px">
      <Controller
        name={name}
        render={({ field: { onChange, value } }) => {
          return (
            <QDatepicker
              placeholder={placeholder}
              value={value}
              onChange={(value) => {
                onChange(value ? formatDatePickerComponentDateToString(value) : value);
              }}
              isClearable={true}
            />
          );
        }}
      />
    </QFormControl>
  );
};

export default DateFilter;
